export const expiredCheckoutUrgencyModalTexts = {
  headingText: 'Your session has expired',
  bodyText: 'Go back to the menu to check your recipes are still in stock',
  ctaText: 'Return to menu',
}

export const almostExpiredCheckoutUrgencyModalTexts = {
  headingText: 'Your session is about to expire',
  bodyText: 'Continue to checkout to secure the recipes in your box',
  ctaText: 'Checkout',
}
